import React, { } from 'react'
import PropTypes from 'prop-types'
import {
  // StyleSheet,
  // Text,
  // View,
} from 'react-native'
// import Button from '@components/button'
// import ButtonHeader from '@components/buttonheader'
// import Feather from '@components/icons/feather'
import FlatList from '@components/flatlist'
import FlatListItem from '@components/flatlistitem'

// import {
//   CommonStyle as cs,
//   scaleSize,
// } from '@styles'
// import Styles from '@styles'
// const { SC /* , Colors */ } = Styles

const LIST_KEY = 'uuid'

const TableClosing = (props) => {
  const {
    // navigation,
    data,
    attrs,
    // onAdd,
    onPress,
    onCheck,
    onMinMaxPress,
    style,
  } = props

  const renderHeader = () => {
    return (
      <FlatListItem
        model={{}}
        attrs={attrs}
        key={`-1`}
        isHeader={true}
        withCheckbox={false}
        {...props}
      />
    )
  }

  const renderItem = ({item}) => {
    return (
      <FlatListItem
        model={item}
        attrs={attrs}
        key={`${item?.[LIST_KEY]}`}
        withCheckbox={false}
        onPress={onPress}
        onCheck={onCheck}
        onMinMaxPress={onMinMaxPress}
        {...props}
      />
    )
  }
  return (
    <FlatList
      data={data}
      renderItem={renderItem}
      keyExtractor={item => item?.[LIST_KEY]}
      ListHeaderComponent={renderHeader}
      style={[style]}
    />
  )
}

// const styles = StyleSheet.create({
// })

TableClosing.propTypes = {
  // navigation: PropTypes.any,
  data: PropTypes.array,
  attrs: PropTypes.array,
  // onAdd: PropTypes.func,
  onPress: PropTypes.func,
  onCheck: PropTypes.func,
  onMinMaxPress: PropTypes.func,
  style: PropTypes.object,
}

export default TableClosing
